import Yup from "@rf/yup/yup-extensions";

export enum IRemaxGlobalStatusSyncLevel {
  AGENCY = "agency",
  AGENT = "agent",
  PROPERTY = "property"
}

export enum ERemaxGlobalStatusSync {
  SUCCESS = "Sincronizado",
  INCOMPLETE = "Incompleto",
  FAILED = "Fallido"
}

export interface IRemaxGlobalStatusSync {
  sync_status: ERemaxGlobalStatusSync;
  sync_error_message: {
    errors: {
      level: IRemaxGlobalStatusSyncLevel;
      code: string;
      message: string;
      context:
        | { property_id: number }
        | { agent_id: number }
        | { agency_id: number };
    }[];
  };
}

export const remaxGlobalStatusSyncSchema = Yup.object({
  sync_status: Yup.string().nullable(),
  sync_error_message: Yup.object({
    errors: Yup.array().of(
      Yup.object({
        level: Yup.string().oneOf(Object.values(IRemaxGlobalStatusSyncLevel)),
        code: Yup.string(),
        message: Yup.string(),
        context: Yup.object({
          property_id: Yup.number(),
          agent_id: Yup.number(),
          agency_id: Yup.number()
        })
      })
    )
  })
});

export type RemaxGlobalStatusSyncType = Yup.InferType<
  typeof remaxGlobalStatusSyncSchema
>;
